// extracted by mini-css-extract-plugin
export default {"root":"ListTag_root__-DKZh","ToBeInvolved":"ListTag_ToBeInvolved__Sc2O-","ToBeSubmitted":"ListTag_ToBeSubmitted__6RJtH","Submitted":"ListTag_Submitted__IgkOV"};